import React from 'react';

import iconPrintV2 from '../public/images/printV2.svg';
import HeaderButton from 'components/HeaderButton';

const PrintButtonV2: React.FC<{
  h?: number;
  w?: number;
  labelClassName?: string;
  gapClassName?: string;
}> = ({ h, w, labelClassName, gapClassName }) => {
  return (
    <HeaderButton
      icon={iconPrintV2}
      alt="print"
      label="Print"
      onClick={() => document.execCommand('print')}
      tooltip="Print"
      iconHeight={h}
      iconWidth={w}
      labelClassName={labelClassName}
      gapClassName={gapClassName}
    />
  );
};

export default PrintButtonV2;
